import { useMemo } from "react";
import { useNexaStore } from "../NexaStore";
import { getRecentQuery } from "../utils";
import { usePageTitle } from "@src/hooks";

const useSetTitle = () => {
    const { events  } = useNexaStore();
    const recentQuery = useMemo(() => {
      return getRecentQuery({ events });
    }, [events.length]);
    usePageTitle({ text: recentQuery ? `Nexa ${recentQuery}` : 'Nexa' });
}

export default useSetTitle;
